// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Az0U","content":"LoadingAlert_content__3zMi_"};